import { useApp } from "@/contexts/AppContext";

/** EN | ع switcher — the whole control toggles the language on click. */
export function LanguageToggle({ className = "" }: { className?: string }) {
  const { language, setLanguage } = useApp();
  const next = language === "en" ? "ar" : "en";

  return (
    <button
      type="button"
      onClick={() => setLanguage(next)}
      aria-label={`Switch language to ${next === "ar" ? "Arabic" : "English"}`}
      className={`flex items-center gap-1 text-label-md font-label-md uppercase tracking-widest cursor-pointer ${className}`}
    >
      <span className={language === "en" ? "text-secondary" : "text-on-surface-variant/60"}>EN</span>
      <span aria-hidden="true" className="text-on-surface-variant/30">
        |
      </span>
      <span className={language === "ar" ? "text-secondary" : "text-on-surface-variant/60"}>ع</span>
    </button>
  );
}
